import { render, staticRenderFns } from "./OwlSlider.vue?vue&type=template&id=1d5e66de&scoped=true&"
import script from "./OwlSlider.vue?vue&type=script&lang=js&"
export * from "./OwlSlider.vue?vue&type=script&lang=js&"
import style0 from "./OwlSlider.vue?vue&type=style&index=0&id=1d5e66de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e66de",
  null
  
)

export default component.exports